import { createFileRoute } from "@tanstack/react-router";
import { DocumentsSection } from "~/routes/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/overview/-components/DocumentsSection";
import { MetricCardsRow } from "~/routes/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/overview/-components/MetricCardsRow";
import { PropertyDataSection } from "~/routes/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/overview/-components/PropertyDataSection";
import { RestrictionsSection } from "~/routes/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/overview/-components/RestrictionsSection";
import { SalesHistorySection } from "~/routes/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/overview/-components/SalesHistorySection";

export const Route = createFileRoute(
  "/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/overview/{-$unitId}",
)({
  component: OverviewPage,
  loader: async ({ context: { i18n } }) => {
    await i18n.loadNamespaces(["property-check-overview", "restrictions"]);

    const title = i18n.t("property-check-overview:meta.title");

    return { meta: { title } };
  },
  head: async (context) => {
    return {
      meta: [
        {
          title: context.loaderData?.meta.title,
        },
      ],
    };
  },
});

function OverviewPage() {
  const { accessAddressId, placeId } = Route.useParams();

  return (
    // On xl+: two-column grid — MetricCardsRow & main content in col 1, PropertyDataSection sticky in col 2.
    // On mobile: flat flex-col in DOM order (MetricCardsRow → PropertyDataSection → rest).
    <div className="flex flex-col gap-6 xl:grid xl:grid-cols-[minmax(0,1fr)_auto] xl:items-start">
      <MetricCardsRow accessAddressId={accessAddressId} />

      {/* Right column on xl (sticky); below MetricCardsRow on mobile */}
      {/* row-span-4 covers all left-column rows so sticky works through full scroll height */}
      <div className="xl:sticky xl:top-32.75 xl:col-start-2 xl:row-span-4 xl:row-start-1 xl:w-99.75 xl:shrink-0">
        <PropertyDataSection
          accessAddressId={accessAddressId}
          placeId={placeId}
        />
      </div>

      {/* Left column rows 2-4 on xl */}
      <SalesHistorySection
        accessAddressId={accessAddressId}
        placeId={placeId}
      />
      <RestrictionsSection
        accessAddressId={accessAddressId}
        placeId={placeId}
      />
      <DocumentsSection
        accessAddressId={accessAddressId}
        placeId={placeId}
      />
    </div>
  );
}
